import { differenceInCalendarDays, formatDate } from 'date-fns'

export interface IDateFormatter {
  formatar: (date: Date, format?: string) => string
  diferencaEmDias: (date1: Date, date2: Date) => number
}

export class DateFormatter implements IDateFormatter {
  formatar(date: Date, format: string = 'dd/MM/yyyy'): string {
    return formatDate(date, format)
  }

  diferencaEmDias(date1: Date, date2: Date): number {
    return differenceInCalendarDays(date1, date2)
  }
}

export default new DateFormatter()
